import ObjectUtils        from '@/utils/object';
import ObjectManipulation from '@/utils/object';
import HestiaApi          from '@/api';

export default class Model {

  static get model() {

    return {};
  }

  static get default() {

    return ObjectManipulation.clone(this.model);
  }

  static get rules() {

    return {};
  }

  static omitRules(...items) {

    return ObjectUtils.omit(this.rules, items);
  }

  static pickRules(...items) {

    return ObjectUtils.pick(this.rules, items);
  }

  static omitFields(...items) {

    return ObjectUtils.omit(this.form, items);
  }

  static pickFields(items) {

    return this.form.filter((field) => {

      return items.includes(field.$id);
    });
  }

  static hookFormRules(form) {

    return form;
  }

  static async getInsee(town, postcode, user) {

    if (!town || !postcode || postcode.length !== 5) {

      return '';
    }

    const insees = await HestiaApi.Geo.commune.search(user.tenantId, {
      'from'  : 0,
      'size'  : 10,
      'query' : {
        'bool' : {
          'must' : [
            {
              'term' : {
                'name.keyword' : {
                  'value' : town
                }
              }
            },
            {
              'term' : {
                'postcodes.keyword' : {
                  'value' : postcode
                }
              }
            }
          ]
        }
      }
    }).json();

    if (insees.hits.total.value >= 1) {

      return insees.hits.hits[0]._source.id;
    }

    return '';
  }
}

